import { useState, useRef } from "react";
import { Button, Form, message } from "antd";

import { useT } from "@/common/utils/translation";
import { sendCode } from "@/services/common";
import CaptchaModal from "@/pages/components/CaptchaModal";

const CodeBtn = function ({ fieldName , type, text, codeType }) {
  let t = useT();
  if(!fieldName){
    fieldName="phone";
  }
  if(!type){
    type = "text";
  }
  if(!text){
    text=t("login_send_the_verification_code");
  }

  const [messageApi, contextHolder] = message.useMessage();
  const [captchaModalVisible, setCaptchaModalVisible] = useState(false);
  const [captchaRefreshTrigger, setCaptchaRefreshTrigger] = useState(0);
  const buttonRef = useRef(null); // 获取按钮DOM元素
  let [count, setCount] = useState(60);
  let [clickble, setClickble] = useState(true);
  let form = Form.useFormInstance();
  const phone = Form.useWatch(fieldName, form);

  const onSend = function () {
    if (phone && form.getFieldError(fieldName).length === 0) {
      // 显示图片验证码弹窗
      setCaptchaModalVisible(true);
    } else {
      messageApi.open({
        type: 'error',
        content: t("common_please_enter_the_correct_phone_number"),
      });
    }
  };

  // 图片验证码验证成功后发送短信
  const handleCaptchaSuccess = async (captchaData) => {
    // 立即关闭弹窗，给用户即时反馈
    setCaptchaModalVisible(false);
    
    try {
      const params = {
        phone: phone,
        code: captchaData.code,
        key: captchaData.key,
        token: captchaData.token, // 添加盲水印token
        sceneCode: codeType || 'LOGIN' // 添加场景码参数
      };

      await sendCode(params);
      
      // 验证成功，显示成功消息
      messageApi.open({
        type: 'success',
        content: t("components_the_verification_code_has_been_sent_please_check_it_carefully_please_do_not_trigger_it_repeatedly_within_1_minute"),
      });
      
      // 验证码发送成功后开始倒计时
      setClickble(false);
      setCount(60);
    } catch (error) {
      messageApi.open({
        type: 'error',
        content: error.message || '发送失败，请重试',
      });
      // 发送失败时重新打开弹窗并自动刷新验证码
      setCaptchaModalVisible(true);
      setCaptchaRefreshTrigger(prev => prev + 1);
    }
  };

  // 关闭图片验证码弹窗
  const handleCaptchaCancel = () => {
    setCaptchaModalVisible(false);
  };

  // 倒计时逻辑
  let btn;
  if (count > 0 && clickble == false) {
    setTimeout(() => {
      setCount(count - 1);
    }, 1000);
    btn = (
      <Button 
        ref={buttonRef}
        disabled={true} 
        type="text" 
        className='p-0 lg:w-[100px]'
      >
        {count}S
      </Button>
    );
  } else {
    if (count === 0) {
      setClickble(true);
      setCount(60);
    }

    btn = (
      <Button 
        ref={buttonRef}
        type={type} 
        onClick={onSend} 
        className='p-0 lg:w-[100px]'
      >
        {text}
      </Button>
    );
  }

  return (
    <>
      {contextHolder}
      {btn}
      
      <CaptchaModal
        visible={captchaModalVisible}
        onOk={handleCaptchaSuccess}
        onCancel={handleCaptchaCancel}
        triggerElement={buttonRef.current} // 传递按钮DOM元素
        refreshTrigger={captchaRefreshTrigger} // 传递刷新触发器
      />
    </>
  );
};
export default CodeBtn;
